import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Contract } from '../../../company/modules/contracts/models/contract.model';

@Component({
  selector: 'ag-contract-volume-pending[contract]',
  // standalone: true,
  // imports: [],
  templateUrl: './contract-volume-pending.component.html',
  styleUrl: './contract-volume-pending.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractVolumePendingComponent implements OnInit {

  @Input() public set contract(value: Contract) {
    this._contract = value;

    this.pendingVolume = this._contract.quantity.value - (this._contract.applied.value || 0);

    if (this._contract.price.type == 'to_be_fixed') {
      // this._contract.summary.fixed_volume puede ser null
      this.pendingVolumeFixed = (this._contract.summary.fixed_volume?.value || 0) - (this._contract.applied.value || 0);

      this.pendingVolumeLabel = this.pendingVolumeFixed == 0 ? 'SLOTS.PENDING_VOLUME_FIXED_ZERO' : this.pendingVolumeFixed < 0 ? 'SLOTS.PENDING_VOLUME_FIXED_NEGATIVE' : 'SLOTS.PENDING_VOLUME_FIXED';
    } else {
      this.pendingVolumeFixed = undefined;
    }
  }

  public get contract(): Contract { return this._contract; }

  /** The language currently used. */
  public currentLang: string;
  public pendingVolumeLabel = 'SLOTS.PENDING_VOLUME_FIXED';
  public pendingVolume: number;
  public pendingVolumeFixed: number;

  public myMath = Math;

  private _contract: Contract;

  constructor(
    private translateService: TranslateService
  ) { }

  /** @ignore */
  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang === 'es' ? undefined : this.translateService.currentLang;
  }
}
